import PicklistMetadata from "../PicklistMetadata";

// The seeded 'Connection Type' list of values: a family heading ("Relational Database") with its
// drivers nested beneath it. Static, so the options come from the session's PICK_VALUES -- which now
// carry ParentUSID, so PlatformSelect draws the list as a tree rather than a flat run of twenty-odd
// entries with no indication of which family each belongs to.
class ConnectionTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Type";
        this.typeValue2 = null;
        this.visibilityType = null;
        // The static path reads each row's ParentUSID and resolves it to the parent's Value itself,
        // so no hierarchyParentField is needed here -- only the request to render as a tree.
        this.hierarchical = true;
    }
}

export default ConnectionTypePicklistMetadata;
